import { RunEstimation } from "common";

export const mergeRunEstimationsByDate = (
  runs: RunEstimation[]
): RunEstimation[] => {
  // Use a Map to store the merged runs, with the date string (YYYY-MM-DD) as the key.
  const mergedRunsMap = new Map<string, RunEstimation>();

  // Iterate over each run in the input array.
  for (const run of runs) {
    // Create a Date object and extract the date part as a unique key.
    // e.g., "2025-08-12T14:49:13.000Z" becomes "2025-08-12"
    const dateKey = new Date(run.runEndDate).toISOString().split("T")[0];

    // Check if we already have an entry for this day.
    const existingEntry = mergedRunsMap.get(dateKey);

    if (existingEntry) {
      // If an entry exists, update its values by adding the current run's data.
      existingEntry.totalCost =
        Math.round((existingEntry.totalCost + run.totalCost) * 100) / 100;
      existingEntry.totalCpuTime += run.totalCpuTime;
      existingEntry.totalMemoryTime += run.totalMemoryTime;
      existingEntry.totalDiskTime += run.totalDiskTime;
      // Note: The runEndDate of the existing entry is kept, representing the first run of that day.
    } else {
      // If no entry exists for this day, create a new one.
      // We create a copy of the run object to avoid modifying the original input data.
      mergedRunsMap.set(dateKey, { ...run });
    }
  }

  // Convert the Map values back into an array to get the final result.
  return Array.from(mergedRunsMap.values());
};

/**
 * TODO: Integrate this function with common format currency
 */
export const formatCurrency = (
  amount: number,
  currency: string = "usd",
  minimumFractionDigits: number = 0,
  maximumFractionDigits: number = 4
): string =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(amount);
